import React from "react";
import styles from "./styles/Page.module.css";

const style = {};

// display: flex;
//   margin-bottom: 80px;
//   flex-direction: column;
//   background-color: white;
//   border: 1px solid lines;

export default function Page({
  title,
  icon = null,
  padded = null,
  right = null,
  size = null,
  children,
}) {
  // const bodyClass = padded ? styles.bodyContPadded : styles.bodyCont;

  const contInnerClass =
    size && size === "large" ? styles.contInnerLarge : styles.contInner;

  return (
    <div className={styles.cont}>
      <div className={contInnerClass}>
        <div className={styles.headerCont}>
          <div className={styles.header}>
            <div className={styles.title}>
              {icon && <div className={styles.icon}>{icon}</div>}
              <div className={styles.titleText}>{title}</div>
            </div>
            {right && <div className={styles.right}>{right}</div>}
          </div>
        </div>
        <div
          className={`flex flex-col bg-white border border-b-[3px] md:rounded-lg mb-20 overflow-hidden 
        ${padded ? "p-10" : ""}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
